<div class="obd">
    <!-- Header -->
    <header class="obd__header">
        <div class="obd__header-row">
            <div class="obd__brand">
                <span class="obd__brand-mark"><i class="fa-solid fa-paper-plane"></i></span>
                <span class="obd__brand-text">Outbound</span>
            </div>

            <!-- Top-level tab nav (company selector stays global, to the right) -->
            <nav class="obd__nav">
                <button *ngFor="let t of tabs"
                        type="button"
                        class="obd__nav-tab"
                        [class.is-active]="activeTab === t.id"
                        (click)="setTab(t.id)">
                    <i class="fa-solid {{ t.icon }}"></i> {{ t.label }}
                </button>
            </nav>

            <div class="obd__header-right">
                <select [(ngModel)]="selectedCompanyId"
                        class="obd__company-select"
                        [disabled]="isLoadingCompanies || companies.length === 0"
                        (ngModelChange)="onCompanyChange()">
                    <option value="" disabled>Select brand</option>
                    <option *ngFor="let c of companies" [value]="c.ID">{{ c.Name }}</option>
                </select>
                <button class="obd__refresh"
                        title="Refresh"
                        [disabled]="!selectedCompanyId"
                        (click)="refresh()">
                    <i class="fa-solid fa-rotate-right"></i>
                </button>
                <button class="obd__btn obd__btn--primary obd__btn--sm"
                        title="Stage a new brand's outbound sequences (paused)"
                        (click)="openLaunchBrand()">
                    <i class="fa-solid fa-rocket"></i> Launch Brand
                </button>
            </div>
        </div>
    </header>

    <main class="obd__main">
        <div class="obd__main-inner">

            <!-- Companies loading / error -->
            <div class="obd__loading" *ngIf="isLoadingCompanies">
                <i class="fa-solid fa-circle-notch fa-spin"></i> Loading brands…
            </div>
            <div class="obd__state obd__state--error" *ngIf="!isLoadingCompanies && companiesError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <div>
                    <strong>Couldn't load brands</strong>
                    <p>{{ companiesError }}</p>
                </div>
            </div>
            <div class="obd__state" *ngIf="!isLoadingCompanies && !companiesError && companies.length === 0">
                <i class="fa-solid fa-building-circle-xmark"></i>
                <div>
                    <strong>No brands found</strong>
                    <p>No Companies are configured in this environment yet.</p>
                </div>
            </div>

            <!-- Per-brand section -->
            <ng-container *ngIf="!isLoadingCompanies && selectedCompanyId">
                <div class="obd__section-head">
                    <h2>{{ selectedCompanyName }}</h2>
                    <span class="obd__section-sub">Reply.io outbound — email outcomes &amp; sequences</span>
                </div>

                <!-- ══════════════════════ OVERVIEW TAB ══════════════════════ -->
                <ng-container *ngIf="activeTab === 'overview'">
                <div class="obd__panels">

                    <!-- ── Stats panel ───────────────────────────── -->
                    <section class="obd__panel obd__panel--full">
                        <div class="obd__panel-head">
                            <i class="fa-solid fa-chart-simple"></i>
                            <h3>Reply Stats</h3>
                            <span class="obd__panel-tag" *ngIf="stats?.integration">{{ stats?.integration }}</span>
                        </div>

                        <div class="obd__loading" *ngIf="statsState.status === 'loading'">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Loading stats…
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="statsState.status === 'not-deployed'">
                            <i class="fa-solid fa-plug-circle-xmark"></i>
                            <div>
                                <strong>Outbound actions not yet deployed to this environment</strong>
                                <p>{{ statsState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__state obd__state--error" *ngIf="statsState.status === 'error'">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <div>
                                <strong>Couldn't load Reply stats</strong>
                                <p>{{ statsState.message }}</p>
                            </div>
                        </div>

                        <ng-container *ngIf="statsState.status === 'ready' && stats">
                            <div class="obd__stat-grid">
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.contacted }}</span>
                                    <span class="obd__stat-label">Contacted</span>
                                </div>
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.delivered }}</span>
                                    <span class="obd__stat-label">Delivered ({{ stats.overview.deliveredPercentage }}%)</span>
                                </div>
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.opened }}</span>
                                    <span class="obd__stat-label">Opened ({{ stats.overview.openedPercentage }}%)</span>
                                </div>
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.replied }}</span>
                                    <span class="obd__stat-label">Replied ({{ stats.overview.repliedPercentage }}%)</span>
                                </div>
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.interested }}</span>
                                    <span class="obd__stat-label">Interested ({{ stats.overview.interestedPercentage }}%)</span>
                                </div>
                                <div class="obd__stat">
                                    <span class="obd__stat-value">{{ stats.overview.bounced }}</span>
                                    <span class="obd__stat-label">Bounced ({{ stats.overview.bouncedPercentage }}%)</span>
                                </div>
                                <div class="obd__stat obd__stat--highlight">
                                    <span class="obd__stat-value">{{ stats.overview.meetingsBooked }}</span>
                                    <span class="obd__stat-label">Meetings booked</span>
                                </div>
                            </div>

                            <div class="obd__meetings" *ngIf="stats.meetings.length > 0">
                                <h4><i class="fa-solid fa-calendar-check"></i> Booked meetings</h4>
                                <table class="obd__table">
                                    <thead>
                                        <tr><th>Contact</th><th>Sequence</th><th>Booked</th><th>Source</th></tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let m of stats.meetings">
                                            <td>{{ m.contactFullName }}</td>
                                            <td>{{ m.sequenceName }}</td>
                                            <td>{{ m.bookedAt | date:'mediumDate' }}</td>
                                            <td>{{ m.source }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </section>

                    <!-- ── Recommendations panel (#1071 P8) ─────── -->
                    <section class="obd__panel obd__panel--full">
                        <div class="obd__panel-head">
                            <i class="fa-solid fa-lightbulb"></i>
                            <h3>Recommendations</h3>
                            <span class="obd__panel-tag" *ngIf="recommendationsState.status === 'ready'">{{ openRecommendations.length }} open</span>
                            <button class="obd__refresh obd__refresh--sm" title="Refresh recommendations"
                                    [disabled]="recommendationsState.status === 'loading'"
                                    (click)="loadRecommendations()">
                                <i class="fa-solid fa-rotate-right"></i>
                            </button>
                        </div>

                        <div class="obd__loading" *ngIf="recommendationsState.status === 'loading'">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Loading recommendations…
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="recommendationsState.status === 'not-deployed'">
                            <i class="fa-solid fa-plug-circle-xmark"></i>
                            <div><strong>Recommendations action not deployed to this environment</strong><p>{{ recommendationsState.message }}</p></div>
                        </div>

                        <div class="obd__state obd__state--error" *ngIf="recommendationsState.status === 'error'">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <div><strong>Couldn't load recommendations</strong><p>{{ recommendationsState.message }}</p></div>
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="recommendationsState.status === 'empty'">
                            <i class="fa-solid fa-inbox"></i>
                            <div><strong>No recommendations</strong><p>{{ recommendationsState.message }}</p></div>
                        </div>

                        <ng-container *ngIf="recommendationsState.status === 'ready'">
                            <div class="obd__state obd__state--error obd__state--inline" *ngIf="recActionError">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <p>{{ recActionError }}</p>
                            </div>

                            <div class="obd__scroll">
                            <table class="obd__table">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Category</th>
                                        <th>Op</th>
                                        <th>Status</th>
                                        <th>Detail</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let r of recommendations">
                                        <td>{{ r.title }}</td>
                                        <td><span class="obd__pill">{{ r.category }}</span></td>
                                        <td>
                                            <span class="obd__pill" [class.obd__pill--active]="r.actionable">{{ r.op }}</span>
                                            <span class="obd__rec-advisory" *ngIf="r.status === 'Open' && !r.actionable" title="Advisory only — edit copy manually">advisory</span>
                                        </td>
                                        <td><span class="obd__pill obd__pill--{{ r.status | lowercase }}">{{ r.status }}</span></td>
                                        <td class="obd__rec-detail">{{ r.detail }}</td>
                                        <td class="obd__rec-actions">
                                            <ng-container *ngIf="r.status === 'Open'">
                                                <button type="button" class="obd__btn obd__btn--primary obd__btn--sm"
                                                        *ngIf="r.actionable"
                                                        [disabled]="recBusyId !== null"
                                                        (click)="applyRecommendation(r)">
                                                    <i class="fa-solid fa-circle-notch fa-spin" *ngIf="recBusyId === r.id"></i>
                                                    <i class="fa-solid fa-check" *ngIf="recBusyId !== r.id"></i>
                                                    Apply
                                                </button>
                                                <button type="button" class="obd__btn obd__btn--ghost obd__btn--sm"
                                                        [disabled]="recBusyId !== null"
                                                        (click)="dismissRecommendation(r)">
                                                    <i class="fa-solid fa-xmark"></i> Dismiss
                                                </button>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </ng-container>
                    </section>

                </div>
                </ng-container>
                <!-- ════════════════════ END OVERVIEW TAB ════════════════════ -->

                <!-- ══════════════════════ SEQUENCES TAB ═════════════════════ -->
                <ng-container *ngIf="activeTab === 'sequences'">

                <!-- ── Streams panel ─────────────────────────── -->
                <section class="obd__panel obd__panel--full obd__panel--streams">
                    <div class="obd__panel-head">
                        <i class="fa-solid fa-arrow-right-arrow-left"></i>
                        <h3>Streams</h3>
                        <span class="obd__panel-tag" *ngIf="streams.length > 0">{{ streams.length }} configured</span>
                        <button class="obd__btn obd__btn--ghost obd__btn--sm" (click)="openAddStream()">
                            <i class="fa-solid fa-plus"></i> Add Stream
                        </button>
                        <button class="obd__enroll-btn obd__enroll-btn--inline" *ngIf="streams.length > 0" (click)="openRunPipeline()">
                            <i class="fa-solid fa-rotate"></i> Sync All
                        </button>
                    </div>

                    <div class="obd__state obd__state--muted" *ngIf="streams.length === 0">
                        <i class="fa-solid fa-inbox"></i>
                        <div>
                            <strong>No streams configured</strong>
                            <p>Add a stream to connect an Apollo list to a Reply sequence.</p>
                        </div>
                    </div>

                    <table class="obd__table" *ngIf="streams.length > 0">
                        <thead>
                            <tr>
                                <th>Apollo List</th>
                                <th>Persona</th>
                                <th>Reply Sequence</th>
                                <th>Sending Domain</th>
                                <th>Daily Cap</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let s of streams; let i = index">
                                <td class="obd__stream-list">{{ s.apolloListName }}</td>
                                <td>{{ s.personaName }}</td>
                                <td>{{ sequenceNameFor(s.replySequenceId) || s.replySequenceId }}</td>
                                <td>{{ s.sendingDomain || '—' }}</td>
                                <td>{{ s.dailyDomainCap != null ? (s.dailyDomainCap | number) : '—' }}</td>
                                <td>
                                    <span class="obd__pill obd__pill--{{ sequenceStatusFor(s.replySequenceId) }}"
                                          *ngIf="sequenceStatusFor(s.replySequenceId)">
                                        {{ sequenceStatusFor(s.replySequenceId) }}
                                    </span>
                                </td>
                                <td class="obd__stream-actions">
                                    <button class="obd__icon-btn" title="Edit" (click)="openEditStream(i)">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button class="obd__icon-btn obd__icon-btn--danger" title="Remove" (click)="deleteStream(i)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>

                <div class="obd__panels">

                    <!-- ── Sequences panel ───────────────────────── -->
                    <section class="obd__panel obd__panel--full">
                        <div class="obd__panel-head">
                            <i class="fa-solid fa-list-ol"></i>
                            <h3>Sequences</h3>
                            <span class="obd__panel-tag" *ngIf="sequencesState.status === 'ready'">{{ activeSequenceCount }} active</span>
                            <button class="obd__btn obd__btn--ghost obd__btn--sm" (click)="openCreateSequence()">
                                <i class="fa-solid fa-plus"></i> New Sequence
                            </button>
                        </div>

                        <div class="obd__loading" *ngIf="sequencesState.status === 'loading'">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Loading sequences…
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="sequencesState.status === 'not-deployed'">
                            <i class="fa-solid fa-plug-circle-xmark"></i>
                            <div>
                                <strong>Outbound actions not yet deployed to this environment</strong>
                                <p>{{ sequencesState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__state obd__state--error" *ngIf="sequencesState.status === 'error'">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <div>
                                <strong>Couldn't load sequences</strong>
                                <p>{{ sequencesState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="sequencesState.status === 'empty'">
                            <i class="fa-solid fa-inbox"></i>
                            <div>
                                <strong>No sequences</strong>
                                <p>{{ sequencesState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__scroll" *ngIf="sequencesState.status === 'ready'">
                            <table class="obd__table">
                                <thead>
                                    <tr><th>Name</th><th>Status</th><th>Health</th><th>Created</th></tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let s of sequences"
                                        (click)="onSequenceClick(s)"
                                        [class.obd__row--selected]="selectedSequence?.id === s.id">
                                        <td>{{ s.name }} <i class="fa-solid fa-box-archive obd__archived" *ngIf="s.isArchived" title="Archived"></i></td>
                                        <td><span class="obd__pill obd__pill--{{ s.status }}">{{ s.status }}</span></td>
                                        <td>{{ s.health || '—' }}</td>
                                        <td>{{ s.created | date:'mediumDate' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <!-- ── Sequence detail panel ─────────────────── -->
                    <section #detailPanel class="obd__panel obd__panel--full" *ngIf="selectedSequence">
                        <div class="obd__panel-head">
                            <i class="fa-solid fa-list-check"></i>
                            <h3>{{ selectedSequence.name }}</h3>
                            <button class="obd__btn obd__btn--ghost obd__btn--sm" (click)="openEditCopy(selectedSequence)">
                                <i class="fa-solid fa-pen-to-square"></i> Edit copy
                            </button>
                            <button class="obd__close-btn" title="Close" (click)="closeDetail()">
                                <i class="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div class="obd__loading" *ngIf="detailState.status === 'loading'">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Loading sequence steps…
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="detailState.status === 'not-deployed'">
                            <i class="fa-solid fa-plug-circle-xmark"></i>
                            <div>
                                <strong>Outbound actions not yet deployed to this environment</strong>
                                <p>{{ detailState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__state obd__state--error" *ngIf="detailState.status === 'error'">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <div>
                                <strong>Couldn't load sequence steps</strong>
                                <p>{{ detailState.message }}</p>
                            </div>
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="detailState.status === 'empty'">
                            <i class="fa-solid fa-inbox"></i>
                            <div><strong>No steps</strong><p>{{ detailState.message }}</p></div>
                        </div>

                        <ng-container *ngIf="detailState.status === 'ready' && sequenceDetail">
                            <!-- Step strip -->
                            <div class="obd__step-strip">
                                <div *ngFor="let step of sequenceDetail.steps; let i = index"
                                     class="obd__step-card"
                                     [class.obd__step-card--selected]="selectedStepIndex === i"
                                     (click)="toggleStepSelection(i)">
                                    <div class="obd__step-day">Day {{ step.dayFromStart }}</div>
                                    <div class="obd__step-label">
                                        <i class="fa-solid fa-envelope" *ngIf="step.type === 'email'"></i>
                                        <i class="fa-brands fa-linkedin" *ngIf="step.type === 'linkedIn'"></i>
                                        <i class="fa-solid fa-list-check" *ngIf="step.type !== 'email' && step.type !== 'linkedIn'"></i>
                                        Touch {{ step.stepNumber }}
                                    </div>
                                    <ng-container *ngIf="getPerfForStep(i) as perf">
                                        <div class="obd__step-rate">{{ perf.replyRate | number:'1.1-1' }}% reply</div>
                                        <div class="obd__step-rate">{{ perf.openRate | number:'1.1-1' }}% open</div>
                                    </ng-container>
                                    <span class="obd__step-ab-pill" *ngIf="step.variants.length > 1">
                                        A/B × {{ step.variants.length }}
                                    </span>
                                </div>
                            </div>

                            <!-- Variant table for selected step (inline per-variant copy editing) -->
                            <div class="obd__variant-table" *ngIf="selectedStepIndex !== null && sequenceDetail.steps[selectedStepIndex]">
                                <table class="obd__table">
                                    <thead>
                                        <tr>
                                            <th>Variant</th>
                                            <th>Subject</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let v of sequenceDetail.steps[selectedStepIndex!].variants; let vi = index">
                                            <tr>
                                                <td><span class="obd__pill">{{ getVariantLetter(vi) }}</span></td>
                                                <td>{{ v.subject || '(no subject / thread reply)' }}</td>
                                                <td>
                                                    <span class="obd__pill" [class.obd__pill--active]="v.isEnabled">
                                                        {{ v.isEnabled ? 'Enabled' : 'Disabled' }}
                                                    </span>
                                                </td>
                                                <td class="obd__variant-actions">
                                                    <button type="button" class="obd__btn obd__btn--ghost"
                                                            *ngIf="!isEditingVariant(selectedStepIndex!, vi)"
                                                            [disabled]="!canEditVariant(v)"
                                                            [title]="canEditVariant(v) ? 'Edit this variant subject and body in place' : 'Reply did not return ids for this variant — cannot edit in place'"
                                                            (click)="openVariantEdit(selectedStepIndex!, vi, v)">
                                                        <i class="fa-solid fa-pen"></i> Edit
                                                    </button>
                                                </td>
                                            </tr>
                                            <!-- Inline editor row -->
                                            <tr *ngIf="isEditingVariant(selectedStepIndex!, vi)">
                                                <td colspan="4">
                                                    <div class="obd__variant-edit">
                                                        <div class="obd__form-group">
                                                            <label class="obd__label" [attr.for]="'variant-subject-' + vi">Subject</label>
                                                            <input class="obd__input" [id]="'variant-subject-' + vi"
                                                                   type="text"
                                                                   [(ngModel)]="variantEditSubject"
                                                                   [disabled]="isSavingVariant"
                                                                   placeholder="Subject line (merge tokens allowed)" />
                                                        </div>

                                                        <div class="obd__form-group">
                                                            <label class="obd__label" [attr.for]="'variant-body-' + vi">Body (HTML)</label>
                                                            <textarea class="obd__textarea" [id]="'variant-body-' + vi"
                                                                      rows="8"
                                                                      [(ngModel)]="variantEditBody"
                                                                      [disabled]="isSavingVariant"
                                                                      placeholder="Email body — HTML allowed. Edits this variant in place; enrolled contacts get the new copy on their next unsent step."></textarea>
                                                        </div>

                                                        <div class="obd__state obd__state--error obd__state--inline" *ngIf="variantEditError">
                                                            <i class="fa-solid fa-triangle-exclamation"></i>
                                                            <p>{{ variantEditError }}</p>
                                                        </div>

                                                        <div class="obd__modal-actions">
                                                            <button type="button" class="obd__btn obd__btn--ghost"
                                                                    [disabled]="isSavingVariant"
                                                                    (click)="closeVariantEdit()">
                                                                Cancel
                                                            </button>
                                                            <button type="button" class="obd__btn obd__btn--primary"
                                                                    [disabled]="isSavingVariant"
                                                                    (click)="saveVariantEdit(selectedStepIndex!, vi, v)">
                                                                <i class="fa-solid fa-circle-notch fa-spin" *ngIf="isSavingVariant"></i>
                                                                {{ isSavingVariant ? 'Saving…' : 'Save variant' }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>

                            <!-- ── Variant rollup sub-section (#1071 P8) ── -->
                            <div class="obd__rollup">
                                <button type="button" class="obd__rollup-toggle" (click)="toggleRollup()">
                                    <i class="fa-solid" [class.fa-chevron-right]="!rollupExpanded" [class.fa-chevron-down]="rollupExpanded"></i>
                                    <i class="fa-solid fa-chart-column"></i>
                                    Variant rollup (click&rarr;meeting per variant + step reply rate)
                                </button>

                                <div class="obd__rollup-body" *ngIf="rollupExpanded">
                                    <div class="obd__loading" *ngIf="rollupState.status === 'loading'">
                                        <i class="fa-solid fa-circle-notch fa-spin"></i> Loading variant rollup…
                                    </div>

                                    <div class="obd__state obd__state--muted" *ngIf="rollupState.status === 'not-deployed'">
                                        <i class="fa-solid fa-plug-circle-xmark"></i>
                                        <div>
                                            <strong>Variant rollup not available in this environment</strong>
                                            <p>{{ rollupState.message }}</p>
                                        </div>
                                    </div>

                                    <div class="obd__state obd__state--error" *ngIf="rollupState.status === 'error'">
                                        <i class="fa-solid fa-triangle-exclamation"></i>
                                        <div><strong>Couldn't load variant rollup</strong><p>{{ rollupState.message }}</p></div>
                                    </div>

                                    <div class="obd__state obd__state--muted" *ngIf="rollupState.status === 'empty'">
                                        <i class="fa-solid fa-inbox"></i>
                                        <div><strong>No variant rollup yet</strong><p>{{ rollupState.message }}</p></div>
                                    </div>

                                    <ng-container *ngIf="rollupState.status === 'ready' && variantRollup">
                                        <!-- The load-bearing caveat: reply rate is step-level, NOT per-variant. -->
                                        <div class="obd__rollup-note" *ngIf="rollupStepLevelNote">
                                            <i class="fa-solid fa-circle-info"></i>
                                            <span>{{ rollupStepLevelNote }}</span>
                                        </div>

                                        <h4 class="obd__rollup-h">Per-variant click&rarr;meeting (GA4 — variant-attributable)</h4>
                                        <table class="obd__table">
                                            <thead>
                                                <tr>
                                                    <th>Step</th>
                                                    <th>Variant</th>
                                                    <th>Sessions</th>
                                                    <th>Engaged</th>
                                                    <th>Conversions</th>
                                                    <th>Step reply rate</th>
                                                    <th>Verdict</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let v of variantRollup.variants">
                                                    <td>{{ v.step }}</td>
                                                    <td><span class="obd__pill">{{ v.variantId }}</span></td>
                                                    <td>{{ v.ga4.sessions | number }}</td>
                                                    <td>{{ v.ga4.engagedSessions | number }}</td>
                                                    <td>{{ v.ga4.conversions | number }}</td>
                                                    <td>
                                                        <span *ngIf="v.stepReplyRate != null">{{ v.stepReplyRate | number:'1.1-1' }}%</span>
                                                        <span *ngIf="v.stepReplyRate == null">—</span>
                                                        <span class="obd__rollup-steplevel" title="Step-level only — not variant-attributable">step-level</span>
                                                    </td>
                                                    <td><span class="obd__verdict obd__verdict--{{ v.verdict }}">{{ v.verdict }}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <h4 class="obd__rollup-h">Per-step reply rate (Reply — variant-blind)</h4>
                                        <table class="obd__table" *ngIf="variantRollup.stepReplyRates.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Step</th>
                                                    <th>Sent</th>
                                                    <th>Replies</th>
                                                    <th>Reply rate</th>
                                                    <th>Variant comparison</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let s of variantRollup.stepReplyRates">
                                                    <td>{{ s.stepDisplayName }}</td>
                                                    <td>{{ s.sent | number }}</td>
                                                    <td>{{ s.replies | number }}</td>
                                                    <td>{{ s.replyRate | number:'1.1-1' }}%</td>
                                                    <td>{{ s.comparisonLabel }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <!-- ── Engagement: who opened / clicked / replied (per sequence) ── -->
                        <div class="obd__engagement">
                            <div class="obd__engagement-head">
                                <i class="fa-solid fa-envelope-open-text"></i>
                                <h4 class="obd__rollup-h">Engagement &mdash; who opened</h4>
                                <span class="obd__panel-tag" *ngIf="engagementState.status === 'ready'">
                                    {{ engagementSummary.opened }} opened &middot; {{ engagementSummary.clicked }} clicked &middot; {{ engagementSummary.replied }} replied
                                </span>
                            </div>

                            <div class="obd__loading" *ngIf="engagementState.status === 'loading'">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Loading engagement&hellip;
                            </div>
                            <div class="obd__state obd__state--muted" *ngIf="engagementState.status === 'not-deployed'">
                                <i class="fa-solid fa-plug-circle-xmark"></i>
                                <div><strong>Engagement not available in this environment</strong><p>{{ engagementState.message }}</p></div>
                            </div>
                            <div class="obd__state obd__state--error" *ngIf="engagementState.status === 'error'">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                <div><strong>Couldn't load engagement</strong><p>{{ engagementState.message }}</p></div>
                            </div>
                            <div class="obd__state obd__state--muted" *ngIf="engagementState.status === 'empty'">
                                <i class="fa-solid fa-inbox"></i>
                                <div><strong>No engagement yet</strong><p>{{ engagementState.message }}</p></div>
                            </div>

                            <ng-container *ngIf="engagementState.status === 'ready'">
                                <table class="obd__engagement-table">
                                    <thead>
                                        <tr>
                                            <th>Contact</th>
                                            <th>Company</th>
                                            <th>Step</th>
                                            <th>Opened</th>
                                            <th>Clicked</th>
                                            <th>Replied</th>
                                            <th>Sent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let r of engagement" [class.obd__row--opened]="r.isOpened">
                                            <td>
                                                <span class="obd__contact-name">{{ r.firstName }} {{ r.lastName }}</span>
                                                <span class="obd__contact-email">{{ r.email }}</span>
                                            </td>
                                            <td>{{ r.company }}</td>
                                            <td>{{ r.sequenceStepDisplayName || ('Step ' + r.sequenceStepNumber) }}</td>
                                            <td><i class="fa-solid" [class.fa-circle-check]="r.isOpened" [class.obd__yes]="r.isOpened" [class.fa-minus]="!r.isOpened" [class.obd__no]="!r.isOpened"></i></td>
                                            <td><i class="fa-solid" [class.fa-circle-check]="r.isClicked" [class.obd__yes]="r.isClicked" [class.fa-minus]="!r.isClicked" [class.obd__no]="!r.isClicked"></i></td>
                                            <td><i class="fa-solid" [class.fa-circle-check]="r.isReplied" [class.obd__yes]="r.isReplied" [class.fa-minus]="!r.isReplied" [class.obd__no]="!r.isReplied"></i></td>
                                            <td>{{ r.deliveryDate ? (r.deliveryDate | date:'MMM d') : '&mdash;' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="obd__engagement-note">Reply reports the open <em>flag</em>, not the open time &mdash; &ldquo;Sent&rdquo; is the send date.</p>
                            </ng-container>
                        </div>
                    </section>

                </div>
                </ng-container>
                <!-- ════════════════════ END SEQUENCES TAB ═══════════════════ -->

                <!-- ══════════════════════ PEOPLE TAB ════════════════════════ -->
                <ng-container *ngIf="activeTab === 'people'">

                <!-- Persona strip -->
                <div class="obd__persona-strip" *ngIf="persona">
                    <i class="fa-solid fa-robot"></i>
                    <span class="obd__persona-name">{{ persona.personaName }}</span>
                    <span class="obd__persona-domain">{{ persona.sendingDomain }}</span>
                    <button class="obd__enroll-btn" (click)="openRunPipeline()">
                        <i class="fa-solid fa-user-plus"></i> Enroll contacts
                    </button>
                    <button class="obd__enroll-btn obd__enroll-btn--inline" (click)="openEnrollReview()">
                        <i class="fa-solid fa-clipboard-check"></i> Enroll (review)
                    </button>
                </div>

                <div class="obd__persona-strip" *ngIf="!persona">
                    <i class="fa-solid fa-robot"></i>
                    <span class="obd__persona-domain">No Reply persona configured for this brand.</span>
                    <button class="obd__enroll-btn" (click)="openEnrollReview()">
                        <i class="fa-solid fa-clipboard-check"></i> Enroll (review)
                    </button>
                </div>

                <div class="obd__panels">

                    <!-- ── Central Pool panel (#1071 P8) ────────── -->
                    <section class="obd__panel obd__panel--full">
                        <div class="obd__panel-head">
                            <i class="fa-solid fa-handshake"></i>
                            <h3>Central Pool — booked meetings</h3>
                            <span class="obd__panel-tag" *ngIf="poolState.status === 'ready'">{{ poolMeetings.length }} total</span>
                            <select class="obd__select obd__select--sm" *ngIf="poolBrands.length > 0" [(ngModel)]="poolBrandFilter">
                                <option value="">All brands</option>
                                <option *ngFor="let b of poolBrands" [value]="b">{{ b }}</option>
                            </select>
                            <button class="obd__btn obd__btn--ghost obd__btn--sm"
                                    [disabled]="isIngesting"
                                    (click)="ingestMeetings()">
                                <i class="fa-solid fa-circle-notch fa-spin" *ngIf="isIngesting"></i>
                                <i class="fa-solid fa-download" *ngIf="!isIngesting"></i>
                                {{ isIngesting ? 'Ingesting…' : 'Ingest' }}
                            </button>
                        </div>

                        <div class="obd__state obd__state--inline" *ngIf="ingestResult">
                            <i class="fa-solid fa-circle-check"></i>
                            <p>
                                Ingested {{ ingestResult.ingested }}, already present {{ ingestResult.alreadyPresent }}, skipped {{ ingestResult.skipped }}.
                            </p>
                        </div>
                        <div class="obd__state obd__state--error obd__state--inline" *ngIf="ingestError">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <p>{{ ingestError }}</p>
                        </div>

                        <div class="obd__loading" *ngIf="poolState.status === 'loading'">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Loading central pool…
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="poolState.status === 'not-deployed'">
                            <i class="fa-solid fa-plug-circle-xmark"></i>
                            <div><strong>Query Records action not deployed to this environment</strong><p>{{ poolState.message }}</p></div>
                        </div>

                        <div class="obd__state obd__state--error" *ngIf="poolState.status === 'error'">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                            <div><strong>Couldn't load central pool</strong><p>{{ poolState.message }}</p></div>
                        </div>

                        <div class="obd__state obd__state--muted" *ngIf="poolState.status === 'empty'">
                            <i class="fa-solid fa-inbox"></i>
                            <div><strong>No meetings</strong><p>{{ poolState.message }}</p></div>
                        </div>

                        <div class="obd__scroll" *ngIf="poolState.status === 'ready'">
                            <table class="obd__table">
                                <thead>
                                    <tr>
                                        <th>Source Brand</th>
                                        <th>Prospect Email</th>
                                        <th>Sequence</th>
                                        <th>Assigned Rep</th>
                                        <th>Booked At</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let m of filteredPoolMeetings">
                                        <td><span class="obd__pill">{{ m.sourceBrand || '—' }}</span></td>
                                        <td>{{ m.prospectEmail || '—' }}</td>
                                        <td>{{ m.sequenceId != null ? (sequenceNameFor(m.sequenceId) || m.sequenceId) : '—' }}</td>
                                        <td>{{ m.assignedRep || '—' }}</td>
                                        <td>{{ m.bookedAt ? (m.bookedAt | date:'short') : '—' }}</td>
                                        <td><span class="obd__pill obd__pill--{{ m.status | lowercase }}">{{ m.status }}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                </div>

                <!-- ── Replies → Activities (re-homed Conduit screen, contact-engagement data) ── -->
                <div class="obd__conduit-embed">
                    <obd-conduit
                        [companyId]="selectedCompanyId"
                        [companyName]="selectedCompanyName"
                        section="activities">
                    </obd-conduit>
                </div>
                </ng-container>
                <!-- ═════════════════════ END PEOPLE TAB ═════════════════════ -->

                <!-- ══════════════════════ BUILD TAB ═════════════════════════ -->
                <ng-container *ngIf="activeTab === 'build'">
                    <div class="obd__build">
                        <obd-sequence-builder
                            [companyId]="selectedCompanyId"
                            [brandName]="selectedCompanyName">
                        </obd-sequence-builder>
                    </div>
                </ng-container>
                <!-- ═════════════════════ END BUILD TAB ══════════════════════ -->

                <!-- ════════════════════ AUDIENCES TAB (Conduit) ════════════════════ -->
                <ng-container *ngIf="activeTab === 'audiences'">
                    <div class="obd__conduit-embed">
                        <obd-conduit
                            [companyId]="selectedCompanyId"
                            [companyName]="selectedCompanyName"
                            section="audiences">
                        </obd-conduit>
                    </div>
                </ng-container>
                <!-- ══════════════════ END AUDIENCES TAB ═════════════════════ -->

                <!-- ════════════════════ BINDINGS TAB (Conduit) ═════════════════════ -->
                <ng-container *ngIf="activeTab === 'bindings'">
                    <div class="obd__conduit-embed">
                        <obd-conduit
                            [companyId]="selectedCompanyId"
                            [companyName]="selectedCompanyName"
                            section="bindings">
                        </obd-conduit>
                    </div>
                </ng-container>
                <!-- ══════════════════ END BINDINGS TAB ══════════════════════ -->

                <!-- ════════════════════ HEALTH TAB (Conduit) ═══════════════════════ -->
                <ng-container *ngIf="activeTab === 'health'">
                    <div class="obd__conduit-embed">
                        <obd-conduit
                            [companyId]="selectedCompanyId"
                            [companyName]="selectedCompanyName"
                            section="health">
                        </obd-conduit>
                    </div>
                </ng-container>
                <!-- ══════════════════ END HEALTH TAB ════════════════════════ -->

            </ng-container>
        </div>
    </main>

    <!-- Stream editor modal -->
    <div class="obd__modal-overlay" *ngIf="streamEditorVisible" (click)="closeStreamEditor()">
        <div class="obd__modal" (click)="$event.stopPropagation()">
            <div class="obd__panel-head">
                <i class="fa-solid fa-arrow-right-arrow-left"></i>
                <h3>{{ editingStreamIndex >= 0 ? 'Edit stream' : 'Add stream' }}</h3>
                <button class="obd__close-btn" *ngIf="!isSavingStream" (click)="closeStreamEditor()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <!-- Apollo list -->
            <div class="obd__form-group">
                <label class="obd__label">Apollo list</label>
                <div class="obd__loading obd__loading--inline" *ngIf="apolloListsLoading">
                    <i class="fa-solid fa-circle-notch fa-spin"></i> Loading lists…
                </div>
                <select class="obd__select" *ngIf="!apolloListsLoading"
                        [(ngModel)]="formApolloListName"
                        [disabled]="isSavingStream">
                    <option value="" disabled>Select an Apollo list…</option>
                    <option *ngFor="let l of apolloLists" [value]="l.name">
                        {{ l.name }} ({{ l.cachedCount | number }} contacts)
                    </option>
                </select>
            </div>

            <!-- Persona name -->
            <div class="obd__form-group">
                <label class="obd__label">Persona name</label>
                <input class="obd__input" type="text"
                       placeholder="e.g. Executive, MemberExperience, TechOps"
                       [(ngModel)]="formPersonaName"
                       [disabled]="isSavingStream" />
                <span class="obd__hint">Used to group contacts — shown in sync results.</span>
            </div>

            <!-- Reply sequence -->
            <div class="obd__form-group">
                <label class="obd__label">Reply sequence</label>
                <select class="obd__select" [(ngModel)]="formReplySequenceId" [disabled]="isSavingStream">
                    <option [value]="0" disabled>Select a Reply sequence…</option>
                    <option *ngFor="let s of sequences" [value]="s.id">
                        {{ s.name }}
                        <ng-container *ngIf="s.status"> — {{ s.status }}</ng-container>
                    </option>
                </select>
            </div>

            <!-- Sending domain (optional) -->
            <div class="obd__form-group">
                <label class="obd__label">Sending domain <span class="obd__label-opt">(optional)</span></label>
                <input class="obd__input" type="text"
                       placeholder="e.g. mail.izzy.io"
                       [(ngModel)]="formSendingDomain"
                       [disabled]="isSavingStream" />
                <span class="obd__hint">Domain this stream sends from — used for per-domain volume pacing.</span>
            </div>

            <!-- Daily domain cap (optional) -->
            <div class="obd__form-group">
                <label class="obd__label">Daily domain cap <span class="obd__label-opt">(optional)</span></label>
                <input class="obd__input" type="number" min="0" step="1"
                       placeholder="e.g. 50"
                       [(ngModel)]="formDailyDomainCap"
                       [disabled]="isSavingStream" />
                <span class="obd__hint">Max sends per day from this sending domain. Leave blank for no cap.</span>
            </div>

            <!-- Error -->
            <div class="obd__state obd__state--error obd__state--inline" *ngIf="streamSaveError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p>{{ streamSaveError }}</p>
            </div>

            <div class="obd__modal-actions">
                <button class="obd__btn obd__btn--ghost" [disabled]="isSavingStream" (click)="closeStreamEditor()">Cancel</button>
                <button class="obd__btn obd__btn--primary"
                        [disabled]="isSavingStream || !formApolloListName || !formPersonaName || !formReplySequenceId"
                        (click)="saveStream()">
                    <i class="fa-solid fa-circle-notch fa-spin" *ngIf="isSavingStream"></i>
                    <i class="fa-solid fa-check" *ngIf="!isSavingStream"></i>
                    {{ isSavingStream ? 'Saving…' : 'Save stream' }}
                </button>
            </div>
        </div>
    </div>

    <!-- Sync modal -->
    <div class="obd__modal-overlay" *ngIf="runPipelineVisible" (click)="closeRunPipeline()">
        <div class="obd__modal obd__modal--wide" (click)="$event.stopPropagation()">
            <div class="obd__panel-head">
                <i class="fa-solid fa-rotate"></i>
                <h3>Sync streams for {{ selectedCompanyName }}</h3>
                <button class="obd__close-btn" *ngIf="!isSyncing" (click)="closeRunPipeline()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <!-- Stream list summary -->
            <div class="obd__modal-streams" *ngIf="!isSyncing && !syncResult && !syncError">
                <p class="obd__modal-body">
                    Pulls new contacts from {{ streams.length }} Apollo list(s) and enrolls them into their Reply sequences.
                    Only contacts not yet in a sequence are enrolled.
                </p>
                <table class="obd__table obd__table--compact">
                    <tbody>
                        <tr *ngFor="let s of streams">
                            <td class="obd__stream-list">{{ s.apolloListName }}</td>
                            <td class="obd__dim">→</td>
                            <td>{{ s.personaName }}</td>
                            <td class="obd__dim">→</td>
                            <td>{{ sequenceNameFor(s.replySequenceId) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Loading -->
            <div class="obd__loading obd__loading--modal" *ngIf="isSyncing">
                <i class="fa-solid fa-circle-notch fa-spin"></i> Syncing… this takes a minute for large lists.
            </div>

            <!-- Error -->
            <div class="obd__state obd__state--error" *ngIf="syncError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <div><strong>Sync failed</strong><p>{{ syncError }}</p></div>
            </div>

            <!-- Results -->
            <ng-container *ngIf="syncResult">
                <div class="obd__sync-summary">
                    <div class="obd__stat obd__stat--sm">
                        <span class="obd__stat-value">{{ syncResult.totalImported }}</span>
                        <span class="obd__stat-label">{{ syncResult.wasDryRun ? 'Would import' : 'Imported' }}</span>
                    </div>
                    <div class="obd__stat obd__stat--sm">
                        <span class="obd__stat-value">{{ syncResult.totalEnrolled }}</span>
                        <span class="obd__stat-label">{{ syncResult.wasDryRun ? 'Would enroll' : 'Enrolled' }}</span>
                    </div>
                    <div class="obd__stat obd__stat--sm" *ngIf="syncResult.totalFailed > 0">
                        <span class="obd__stat-value obd__stat-value--warn">{{ syncResult.totalFailed }}</span>
                        <span class="obd__stat-label">Failed</span>
                    </div>
                </div>
                <table class="obd__table obd__table--compact">
                    <thead>
                        <tr><th>Stream</th><th>Apollo</th><th>Imported</th><th>Already in seq</th><th>Enrolled</th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of syncResult.results">
                            <td>{{ r.personaName }}</td>
                            <td>{{ r.apolloContacts }}</td>
                            <td>{{ r.imported }}</td>
                            <td class="obd__dim">{{ r.alreadyEnrolled }}</td>
                            <td [class.obd__cell--success]="r.enrolled > 0">{{ r.enrolled }}</td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <div class="obd__modal-actions" *ngIf="!isSyncing">
                <button class="obd__btn obd__btn--ghost" (click)="closeRunPipeline()">
                    {{ syncResult ? 'Close' : 'Cancel' }}
                </button>
                <ng-container *ngIf="!syncResult">
                    <button class="obd__btn obd__btn--ghost" (click)="runSync(true)">
                        <i class="fa-solid fa-magnifying-glass"></i> Dry Run
                    </button>
                    <button class="obd__btn obd__btn--primary" (click)="runSync(false)">
                        <i class="fa-solid fa-rotate"></i> Sync Now
                    </button>
                </ng-container>
                <button class="obd__btn obd__btn--primary" *ngIf="syncResult && syncResult.wasDryRun" (click)="runSync(false)">
                    <i class="fa-solid fa-rotate"></i> Run Live
                </button>
            </div>
        </div>
    </div>

    <!-- Create-sequence modal (Gap 1) -->
    <div class="obd__modal-overlay" *ngIf="createSequenceVisible" (click)="closeCreateSequence()">
        <div class="obd__modal obd__modal--wide" (click)="$event.stopPropagation()">
            <div class="obd__panel-head">
                <i class="fa-solid fa-plus"></i>
                <h3>New sequence for {{ selectedCompanyName }}</h3>
                <button class="obd__close-btn" *ngIf="!isCreatingSequence" (click)="closeCreateSequence()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <!-- Editor (hidden once created) -->
            <ng-container *ngIf="!createResult">
                <p class="obd__modal-body">
                    <i class="fa-solid fa-shield-halved"></i>
                    The sequence is created <strong>paused</strong>. Review and start it manually from the Reply dashboard — this screen never starts a sequence.
                </p>

                <div class="obd__form-group">
                    <label class="obd__label">Sequence name override <span class="obd__hint">(optional — defaults to the name in the doc)</span></label>
                    <input class="obd__input" type="text"
                           placeholder="e.g. Izzy Executive Stream"
                           [(ngModel)]="createNameOverride"
                           [disabled]="isCreatingSequence" />
                </div>

                <div class="obd__form-group">
                    <label class="obd__label">Copy document (markdown)</label>
                    <textarea class="obd__textarea"
                              rows="16"
                              [placeholder]="copyDocPlaceholder"
                              [(ngModel)]="createCopyDocument"
                              [disabled]="isCreatingSequence"></textarea>
                </div>
            </ng-container>

            <!-- Loading -->
            <div class="obd__loading obd__loading--modal" *ngIf="isCreatingSequence">
                <i class="fa-solid fa-circle-notch fa-spin"></i> Creating paused sequence…
            </div>

            <!-- Error -->
            <div class="obd__state obd__state--error obd__state--inline" *ngIf="createError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p>{{ createError }}</p>
            </div>

            <!-- Result (parsed step strip + warnings) -->
            <ng-container *ngIf="createResult">
                <div class="obd__state obd__state--muted obd__state--inline">
                    <i class="fa-solid fa-circle-check"></i>
                    <div>
                        <strong>Created sequence #{{ createResult.sequenceId }} — status "{{ createResult.status }}" (paused)</strong>
                        <p>{{ createResult.steps.length }} step(s) parsed. Start it manually from the Reply dashboard.</p>
                    </div>
                </div>
                <a class="obd__link" *ngIf="createResult.dashboardUrl" [href]="createResult.dashboardUrl" target="_blank" rel="noopener">
                    <i class="fa-solid fa-arrow-up-right-from-square"></i> Open in Reply dashboard
                </a>
                <table class="obd__table obd__table--compact">
                    <thead>
                        <tr><th>Touch</th><th>Variants</th><th>Notes</th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let s of createResult.steps">
                            <td>{{ s.touchNumber }}</td>
                            <td>{{ s.variantCount }}</td>
                            <td class="obd__dim">{{ s.degradations.join('; ') || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="obd__warn-list" *ngIf="createResult.warnings.length > 0">
                    <h4><i class="fa-solid fa-triangle-exclamation"></i> {{ createResult.warnings.length }} warning(s)</h4>
                    <ul><li *ngFor="let w of createResult.warnings">{{ w }}</li></ul>
                </div>
            </ng-container>

            <div class="obd__modal-actions" *ngIf="!isCreatingSequence">
                <button class="obd__btn obd__btn--ghost" (click)="closeCreateSequence()">
                    {{ createResult ? 'Close' : 'Cancel' }}
                </button>
                <button class="obd__btn obd__btn--primary" *ngIf="!createResult"
                        [disabled]="!createCopyDocument.trim()"
                        (click)="submitCreateSequence()">
                    <i class="fa-solid fa-circle-pause"></i> Create (paused)
                </button>
            </div>
        </div>
    </div>

    <!-- Edit-copy modal (Gap 2) -->
    <div class="obd__modal-overlay" *ngIf="editCopyVisible" (click)="closeEditCopy()">
        <div class="obd__modal obd__modal--wide" (click)="$event.stopPropagation()">
            <div class="obd__panel-head">
                <i class="fa-solid fa-pen-to-square"></i>
                <h3>Edit copy — {{ editSequence?.name }}</h3>
                <button class="obd__close-btn" *ngIf="!isEditingCopy" (click)="closeEditCopy()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <ng-container *ngIf="!editResult || (editResult && editResult.wasDryRun)">
                <p class="obd__modal-body">
                    <i class="fa-solid fa-shield-halved"></i>
                    Updates subject lines + bodies <strong>in place</strong>. Sequence structure and run state are untouched; enrolled contacts get the new copy on their next unsent step. Step count must match the existing sequence.
                </p>
                <div class="obd__form-group">
                    <label class="obd__label">Revised copy document (markdown)</label>
                    <textarea class="obd__textarea"
                              rows="16"
                              [placeholder]="copyDocPlaceholder"
                              [(ngModel)]="editCopyDocument"
                              [disabled]="isEditingCopy"></textarea>
                </div>
            </ng-container>

            <div class="obd__loading obd__loading--modal" *ngIf="isEditingCopy">
                <i class="fa-solid fa-circle-notch fa-spin"></i> {{ editResult ? 'Applying…' : 'Computing plan…' }}
            </div>

            <div class="obd__state obd__state--error obd__state--inline" *ngIf="editError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p>{{ editError }}</p>
            </div>

            <ng-container *ngIf="editResult">
                <div class="obd__state obd__state--muted obd__state--inline">
                    <i class="fa-solid" [class.fa-magnifying-glass]="editResult.wasDryRun" [class.fa-circle-check]="!editResult.wasDryRun"></i>
                    <div>
                        <strong *ngIf="editResult.wasDryRun">Dry run — no writes were made</strong>
                        <strong *ngIf="!editResult.wasDryRun">Applied</strong>
                        <p>
                            {{ editResult.wasDryRun ? 'Would update' : 'Updated' }} {{ editResult.updated }} variant(s),
                            {{ editResult.wasDryRun ? 'create' : 'created' }} {{ editResult.created }}
                            across {{ editResult.stepCount }} step(s).
                        </p>
                    </div>
                </div>
                <div class="obd__warn-list" *ngIf="editResult.warnings.length > 0">
                    <h4><i class="fa-solid fa-triangle-exclamation"></i> {{ editResult.warnings.length }} warning(s)</h4>
                    <ul><li *ngFor="let w of editResult.warnings">{{ w }}</li></ul>
                </div>
            </ng-container>

            <div class="obd__modal-actions" *ngIf="!isEditingCopy">
                <button class="obd__btn obd__btn--ghost" (click)="closeEditCopy()">
                    {{ editResult && !editResult.wasDryRun ? 'Close' : 'Cancel' }}
                </button>
                <ng-container *ngIf="!editResult || editResult.wasDryRun">
                    <button class="obd__btn obd__btn--ghost"
                            [disabled]="!editCopyDocument.trim()"
                            (click)="submitEditCopy(true)">
                        <i class="fa-solid fa-magnifying-glass"></i> Dry run
                    </button>
                    <button class="obd__btn obd__btn--primary"
                            [disabled]="!editCopyDocument.trim()"
                            (click)="submitEditCopy(false)">
                        <i class="fa-solid fa-check"></i> Apply
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Enroll-review modal (Gap 3) -->
    <div class="obd__modal-overlay" *ngIf="enrollReviewVisible" (click)="closeEnrollReview()">
        <div class="obd__modal obd__modal--wide" (click)="$event.stopPropagation()">
            <div class="obd__panel-head">
                <i class="fa-solid fa-clipboard-check"></i>
                <h3>Enroll people — {{ selectedCompanyName }}</h3>
                <button class="obd__close-btn" *ngIf="!isEnrolling" (click)="closeEnrollReview()">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>

            <ng-container *ngIf="!enrollResult || enrollResult.wasDryRun">
                <p class="obd__modal-body">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    Run a <strong>dry run</strong> first to review the per-persona plan. Live enroll into an <strong>active</strong> sequence sends real email and requires the acknowledgement below.
                </p>

                <!-- People — row editor -->
                <div class="obd__form-group">
                    <label class="obd__label">People</label>
                    <div class="obd__enroll-rows">
                        <div class="obd__enroll-row obd__enroll-row--head">
                            <span>Email</span>
                            <span>First name</span>
                            <span>Company</span>
                            <span>Persona</span>
                            <span class="obd__enroll-row-actions"></span>
                        </div>
                        <div class="obd__enroll-row"
                             *ngFor="let row of enrollRows; let i = index; trackBy: trackEnrollRow">
                            <input class="obd__input" type="email"
                                   placeholder="jane@incose.org"
                                   [(ngModel)]="row.email"
                                   [disabled]="isEnrolling" />
                            <input class="obd__input" type="text"
                                   placeholder="Jane"
                                   [(ngModel)]="row.firstName"
                                   [disabled]="isEnrolling" />
                            <input class="obd__input" type="text"
                                   placeholder="INCOSE"
                                   [(ngModel)]="row.company"
                                   [disabled]="isEnrolling" />
                            <select class="obd__select" *ngIf="enrollHasStreams"
                                    [(ngModel)]="row.persona"
                                    (ngModelChange)="syncEnrollPersonaSeq()"
                                    [disabled]="isEnrolling">
                                <option value="" disabled>Choose…</option>
                                <option *ngFor="let p of enrollPersonaOptions" [value]="p">{{ p }}</option>
                            </select>
                            <input class="obd__input" type="text" *ngIf="!enrollHasStreams"
                                   placeholder="Persona"
                                   [(ngModel)]="row.persona"
                                   (ngModelChange)="syncEnrollPersonaSeq()"
                                   [disabled]="isEnrolling" />
                            <button class="obd__icon-btn obd__enroll-row-actions"
                                    title="Remove person"
                                    [disabled]="isEnrolling"
                                    (click)="removeEnrollRow(i)">
                                <i class="fa-solid fa-trash-can"></i>
                            </button>
                        </div>
                    </div>
                    <button class="obd__btn obd__btn--ghost obd__btn--sm"
                            [disabled]="isEnrolling"
                            (click)="addEnrollRow()">
                        <i class="fa-solid fa-plus"></i> Add person
                    </button>
                    <span class="obd__hint">Domain is read from each email automatically. Blank rows are ignored.</span>
                </div>

                <!-- Persona → Sequence map — auto-derived from the personas used above -->
                <div class="obd__form-group" *ngIf="enrollUsedPersonas.length > 0">
                    <label class="obd__label">Sequence for each persona</label>
                    <div class="obd__enroll-map">
                        <div class="obd__enroll-map-row" *ngFor="let persona of enrollUsedPersonas">
                            <span class="obd__enroll-map-persona">{{ persona }}</span>
                            <i class="fa-solid fa-arrow-right obd__enroll-map-arrow"></i>
                            <select class="obd__select"
                                    [(ngModel)]="enrollPersonaSeq[persona]"
                                    [disabled]="isEnrolling">
                                <option [ngValue]="0" disabled>Select a sequence…</option>
                                <option *ngFor="let s of sequences" [ngValue]="s.id">
                                    {{ s.name }}
                                    <ng-container *ngIf="s.status"> — {{ s.status }}</ng-container>
                                </option>
                            </select>
                        </div>
                    </div>
                    <span class="obd__hint">Pre-filled from this brand's stream config where available — change any to override.</span>
                </div>
            </ng-container>

            <div class="obd__loading obd__loading--modal" *ngIf="isEnrolling">
                <i class="fa-solid fa-circle-notch fa-spin"></i> {{ enrollResult ? 'Enrolling…' : 'Planning…' }}
            </div>

            <div class="obd__state obd__state--error obd__state--inline" *ngIf="enrollError">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p>{{ enrollError }}</p>
            </div>

            <!-- Plan / result -->
            <ng-container *ngIf="enrollResult">
                <div class="obd__sync-summary">
                    <div class="obd__stat obd__stat--sm">
                        <span class="obd__stat-value">{{ enrollResult.plan.eligibleContacts }}</span>
                        <span class="obd__stat-label">Eligible</span>
                    </div>
                    <div class="obd__stat obd__stat--sm" *ngIf="!enrollResult.wasDryRun">
                        <span class="obd__stat-value">{{ enrollResult.enrolledCount }}</span>
                        <span class="obd__stat-label">Enrolled</span>
                    </div>
                    <div class="obd__stat obd__stat--sm" *ngIf="enrollResult.plan.skipped.length > 0">
                        <span class="obd__stat-value obd__stat-value--warn">{{ enrollResult.plan.skipped.length }}</span>
                        <span class="obd__stat-label">Skipped</span>
                    </div>
                </div>
                <table class="obd__table obd__table--compact">
                    <thead>
                        <tr><th>Persona</th><th>Sequence</th><th>Contacts</th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of enrollResult.plan.personas">
                            <td>{{ p.persona }}</td>
                            <td>{{ sequenceNameFor(p.sequenceId) }}
                                <span class="obd__pill obd__pill--{{ sequenceStatusFor(p.sequenceId) }}"
                                      *ngIf="sequenceStatusFor(p.sequenceId)">{{ sequenceStatusFor(p.sequenceId) }}</span>
                            </td>
                            <td>{{ p.contactCount }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="obd__warn-list" *ngIf="enrollResult.plan.skipped.length > 0">
                    <h4><i class="fa-solid fa-triangle-exclamation"></i> {{ enrollResult.plan.skipped.length }} skipped</h4>
                    <ul><li *ngFor="let s of enrollResult.plan.skipped">{{ s.email || '(no email)' }} — {{ s.reason }}</li></ul>
                </div>
            </ng-container>

            <!-- Acknowledge gate (only meaningful before live enroll) -->
            <label class="obd__ack" *ngIf="!isEnrolling && (!enrollResult || enrollResult.wasDryRun)">
                <input type="checkbox" [(ngModel)]="enrollAcknowledgeActive" />
                <span>Acknowledge active sequence — I understand enrolling into an active sequence sends real email immediately.</span>
            </label>

            <div class="obd__modal-actions" *ngIf="!isEnrolling">
                <button class="obd__btn obd__btn--ghost" (click)="closeEnrollReview()">
                    {{ enrollResult && !enrollResult.wasDryRun ? 'Close' : 'Cancel' }}
                </button>
                <ng-container *ngIf="!enrollResult || enrollResult.wasDryRun">
                    <button class="obd__btn obd__btn--ghost" (click)="submitEnroll(true)">
                        <i class="fa-solid fa-magnifying-glass"></i> Dry run
                    </button>
                    <button class="obd__btn obd__btn--primary"
                            [disabled]="!enrollAcknowledgeActive"
                            (click)="submitEnroll(false)">
                        <i class="fa-solid fa-user-plus"></i> Enroll live
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Launch Brand modal — provide-only, stages PAUSED-ready. Top-level sibling
         so it renders regardless of which (if any) per-brand modal is open. -->
    <obd-launch-brand-pipeline-modal
        [visible]="launchBrandVisible"
        [companyContext]="selectedCompanyId"
        (closed)="closeLaunchBrand()"
        (launched)="onBrandLaunched($event)">
    </obd-launch-brand-pipeline-modal>
</div>
